import React from 'react';
import { useUser } from 'packages/smart-home-support/hooks';
import { isInTestGroup } from 'packages/smart-home-support/utils';
import { TestGroup } from 'packages/smart-home-support/models';
import HomeTabActivation from './HomeTabActivation';
import HomeTabOriginal from './HomeTabOriginal';
import { ProfilePageProps } from '../../models';

const HomeTab: React.FC<ProfilePageProps> = (props) => {
  const user = useUser();
  const showActivationVersion = isInTestGroup(user, TestGroup.Warranty_Redesign);

  return showActivationVersion
    ? (<HomeTabActivation { ...props } />)
    : (<HomeTabOriginal { ...props } />);
};

export default HomeTab;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/HomeTab.tsx